module.exports = __webpack_public_path__ + "img/auth1.be1e2cc1.png";